var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.906,
    height: 36.906,
    viewBox: "0 0 36.906 36.906",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1227.644 890.822) translate(1227.644 -890.822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1227.644-882.667l8.156-8.155A14.345,14.345,0,0,0,1227.644-882.667Z",
    transform: "translate(-1227.644 890.822)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.015-890.822l8.155,8.155A14.344,14.344,0,0,0,1251.015-890.822Z",
    transform: "translate(-1222.264 890.822)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.8-859.3l-8.156-8.155A14.345,14.345,0,0,0,1235.8-859.3Z",
    transform: "translate(-1227.644 896.202)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.17-867.451l-8.155,8.155A14.343,14.343,0,0,0,1259.17-867.451Z",
    transform: "translate(-1222.264 896.202)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.458-866.12l-3.389,3.39a14.228,14.228,0,0,0,2.257-7.715c0-.256-.007-.511-.021-.764l-2.635,2.636,0,0a14.325,14.325,0,0,0,.563-3.975,14.318,14.318,0,0,0-.563-3.975l0,0,2.635,2.636c.014-.253.021-.508.021-.764a14.225,14.225,0,0,0-2.257-7.715l3.389,3.39a14.321,14.321,0,0,0-11.11-11.111l3.39,3.39a14.227,14.227,0,0,0-7.716-2.257q-.384,0-.763.02l2.64,2.64a14.315,14.315,0,0,0-3.975-.563,14.312,14.312,0,0,0-3.974.563l2.64-2.64c-.252-.014-.508-.02-.764-.02a14.229,14.229,0,0,0-7.715,2.257l3.389-3.39a14.322,14.322,0,0,0-11.11,11.111l3.39-3.39a14.225,14.225,0,0,0-2.257,7.715c0,.256.006.51.02.764l2.636-2.636,0,0a14.318,14.318,0,0,0-.564,3.975,14.325,14.325,0,0,0,.564,3.975l0,0-2.636-2.636c-.014.253-.02.508-.02.764a14.228,14.228,0,0,0,2.257,7.715l-3.39-3.39a14.324,14.324,0,0,0,11.11,11.111l-3.389-3.39a14.24,14.24,0,0,0,7.715,2.257c.256,0,.512-.006.764-.02l-2.64-2.641a14.268,14.268,0,0,0,3.974.565,14.27,14.27,0,0,0,3.975-.565l-2.64,2.641c.252.014.507.02.763.02a14.238,14.238,0,0,0,7.716-2.257l-3.39,3.39A14.322,14.322,0,0,0,1263.458-866.12Z",
    transform: "translate(-1227.472 890.994)",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconWhite);
export default __webpack_public_path__ + "static/media/logoIcon_white.c8b961881203fa573d6712225219fcf6.svg";
export { ForwardRef as ReactComponent };